const Footer = () => {
    return (
      <footer>
        <p>
          Design and Built By <a href="https://imranh.netlify.app">Imran</a>
        </p>
      </footer>
    );
  };
  
  export default Footer;
  